import { Filder } from "@/project/documents/types"

export type DocumentsBreadcrumbState = {
  breadcrumb: Array<{
    id: number,
    name: string,
    basename: string,
    type: string,
    parentFolderId?: number | null,
    numbering?: string | null,
    children?: Array<Filder>,
    rights?: Object,
    specialFolder?: string,
  }>
  // Prevents outdated folder navigation for breadcrumb when user navigates quickly
  folderNavigationToken: number,
}
export const state: DocumentsBreadcrumbState = {
  breadcrumb: [],
  folderNavigationToken: 0,
}
